import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import CurrencyInput from '../../../../helpers/CurrencyInput';
import MultiTagInput from '../../component/MultiTagInput/MultiTagInput';
import { getToken } from '../../../../helpers/Jwt';
import { confirmModal } from '../../../../helpers/PromptUtils';
import AccountComponent from './component/AccountComponent';
import InputOption from '../../component/InputOption/InputOption';
import FormatTransaction from '../../component/FormatTransaction/FormatTransaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears } from '@fortawesome/free-solid-svg-icons';

const EntryJournal = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState(null);
  const [itemData, setItemData] = useState([]);

  const [initialValues, setInitialValues] = useState({});

  const [error, setError] = useState(null);
  const [cashbank, setCashBank] = useState([]);
  const [contact, setContact] = useState([]);
  const [accountRelationLabel, setAccountRelationLabel] = useState("Akun");

  
  const [accounts, setAccounts] = useState([]);

  const [subtotalDebit, setSubtotalDebit] = useState(0);
  const [subtotalCredit, setSubtotalCredit] = useState(0);
  
  const [selectedTags, setSelectedTags] = useState([]);

  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";
  const PATH_TRANSACTION = "api/erpppsu/journal";
  const PATH_CONTACT = "api/erpppsu/contact/all";
  
  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(`${BASE_URL}${PATH_TRANSACTION}/detail?id=${id}`).then((data) => {
        setDetailData(data)
      });

      fetchData(`${BASE_URL}${PATH_TRANSACTION}/items?id=${id}`).then((data) => {
        setItemData(data)
      });
    }
  }, [id]);

  useEffect(() => {
    if (detailData != null) {
      setInitialValues(prev => ({
        ...prev,
        date: detailData?.date || '',
        no_transaction: detailData?.no_transaction || ''
      }));
    }


  }, [detailData]);

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}`,).then((data) => {
      setCashBank(data);
    });

    fetchData(`${BASE_URL}${PATH_CONTACT}`,).then((data) => {
      setContact(data);
    });
  }, []);

  
  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const handleAccountUpdate = (data) => {
    setAccounts(data);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        id,
        ...values,
        selectedTags,
        accounts
      };

      const response = await axios.post(`${BASE_URL}${PATH_TRANSACTION}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });
      
      const confirmed = confirmModal(response.data);
      if (confirmed) {
        window.location.reload();
      }
    } catch (error) {
      alert(error.response.data);

    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className='flex items-center justify-between px-5'>
        <h2 className="text-2xl font-bold mb-4">
          Jurnal Umum
        </h2>

        <div className='flex items-center'>
        </div>
      </div>

      {/* Formik Form */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div className="p-3">
                  <FormatTransaction
                    show={isFormatTransactionOpen}
                    onClose={() => setFormatTransactionOpen(false)}
                    apply={(value) => {
                      setFieldValue('no_transaction', value);
                    }} />

                  <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                    No. Transaksi&nbsp;
                    <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                      <FontAwesomeIcon icon={faGears} />
                    </button>
                  </label>
                  <Field
                    name="no_transaction"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                  <Field
                    type='date'
                    name="date"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                </div>                

                <div className="p-3">
                  <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>
              </div>

              <AccountComponent
                label={accountRelationLabel}
                items={itemData}
                onAccountUpdated={handleAccountUpdate}
                onTotalCreditUpdated={(value) => {
                  setSubtotalCredit(value);
                }}
                onTotalDebitUpdated={(value) => {
                  setSubtotalDebit(value);
                }}
              />

              <div className="container m-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div></div>
                <div></div>
                <div className='col-span-2 flex  justify-between'>
                  <div className="items-center">
                    <h1 className="text-lg font-semibold">Total Kredit</h1>
                    <h1 className="text-lg font-semibold">Rp{subtotalCredit.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                  </div>

                  <div className="items-center ">
                    <h1 className="text-lg font-semibold">Total Debit</h1>
                    <h1 className="text-lg font-semibold">Rp{subtotalDebit.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                  </div>
                </div>
              </div>



              <div className="flex items-center justify-end mt-5">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  )
}

export default EntryJournal;